// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"Loading_loadingOverlay__Wh2ty","spinner":"Loading_spinner__3Vnwt","spin":"Loading_spin__8utgK","loadingImage":"Loading_loadingImage__PoNcV"};